<mat-toolbar class="titulopartes">Dados da Turma</mat-toolbar>
<div fxLayout="row" style="margin-bottom: 20px">
    <mat-form-field fxFlex="45%" fxFlexOffset="20px">
        <input #descricao matInput maxlength="200" name="descricao" placeholder="Descrição"
            [(ngModel)]="turma.descricao" required>
        <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlexOffset="20px" fxFlex="30%">
        <mat-label>Niveis da turma</mat-label>
        <mat-select [(ngModel)]="turma.niveisTurma.id" name="nivelTurma" 
                    (selectionChange)="setNivelTurma()">
            <mat-option></mat-option>
            <mat-option *ngFor="let u of niveisTurma"
                        [value]="u.id">
                {{u.descricao}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field fxFlexOffset="20px" fxFlex="20%">
        <mat-label>Turno</mat-label>
        <mat-select [(ngModel)]="turma.turno" name="turno">
            <mat-option></mat-option>
            <mat-option *ngFor="let u of turnos.tipos" [value]="u.id">
                {{u.descricao}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex fxFlexOffset="20px">
        <mat-label>Programa</mat-label>
        <mat-select [(ngModel)]="turma.programa.id" name="programa" 
                    [required]="!turma.projeto?.id"
                    (selectionChange)="carregarPrograma()">
            <mat-option></mat-option>
            <mat-option *ngFor="let u of programas" [value]="u.id">
                {{u.nome}}
            </mat-option>
        </mat-select>
        <mat-hint *ngIf="programas?.length === 0" align="start">Nenhum programa cadastrado</mat-hint>
    </mat-form-field>


    <mat-form-field fxFlex>
        <mat-label>Projeto</mat-label>
        <mat-select [(ngModel)]="turma.projeto.id" 
                    name="projeto" 
                    (selectionChange)="carregarProjeto()"
                    [required]="!turma.programa?.id">
            <mat-option></mat-option>
            <mat-option *ngFor="let u of projetos" [value]="u.id">
                {{u.nome}}
            </mat-option>
        </mat-select>
        <mat-hint *ngIf="projetos?.length === 0" align="start">Nenhum projeto cadastrado</mat-hint>
    </mat-form-field>

</div>


<mat-toolbar class="titulopartes">Período</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="20%" fxFlexOffset="20px">
        <input matInput name="dataInicioTurma" 
               [matDatepicker]="dataInicioTurma" placeholder="Data de Início"
               [min]="turma.projeto.dataInicio || turma.programa.dataInicio"
               [(ngModel)]="turma.dataInicioTurma" (input)="onMascaraDataInput($event)" required>
        <mat-datepicker-toggle matSuffix [for]="dataInicioTurma"></mat-datepicker-toggle>
        <mat-datepicker #dataInicioTurma></mat-datepicker>


        <mat-error *ngIf="turma.projeto?.id; else errorPrograma">A data deve ser maior/igual que a data do projeto</mat-error>
        <ng-template #errorPrograma>
            <mat-error *ngIf="turma.programa?.id">A data deve ser maior/igual que a data do programa</mat-error>
        </ng-template>
    </mat-form-field>

    <mat-form-field fxFlex="20%">
        <input matInput name="dataFimTurma" 
               [matDatepicker]="dataFimTurma" 
               placeholder="Data Fim"
               [min]="turma.dataInicioTurma"
               [(ngModel)]="turma.dataFimTurma" (input)="onMascaraDataInput($event)" required>
        <mat-datepicker-toggle matSuffix [for]="dataFimTurma"></mat-datepicker-toggle>
        <mat-datepicker #dataFimTurma></mat-datepicker>

        <mat-error>Inferior a data de início</mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="15%">
        <input matInput type="number" name="numeroMaximoParticipantes" placeholder="Máximo Participantes"
            [(ngModel)]="turma.numeroMaximoParticipantes">
    </mat-form-field>

</div>

<!-- OBSERVAÇÕES -->
<mat-toolbar class="titulopartes">Observações</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="95%" appearance="outline">
        <mat-label>Observações:</mat-label>
        <textarea #observacao matInput name="observacao" [(ngModel)]="turma.observacao" cdkTextareaAutosize
            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200"></textarea>
        <mat-hint align="end">{{observacao.value.length}} / 200</mat-hint>
    </mat-form-field>
</div>
